/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Cipher_LabelInputs */

const bn_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাইফার`)
};

const de_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiffre`)
};

const el_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κρυπτογράφημα`)
};

const en_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipher`)
};

const es_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cifrar`)
};

const fr_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiffrer`)
};

const hi_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिफ़र`)
};

const hu_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejtjel`)
};

const id_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandi`)
};

const it_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cifra`)
};

const ja_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗号`)
};

const ko_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`암호`)
};

const nl_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijfer`)
};

const pl_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szyfr`)
};

const pt_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cifra`)
};

const ru_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шифр`)
};

const sv_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiffer`)
};

const tr_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şifre`)
};

const uk_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шифр`)
};

const vi_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mật mã`)
};

const zh_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码`)
};

const zh_hant_theme_cipher_label = /** @type {(inputs: Theme_Cipher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密碼`)
};

/**
* | output |
* | --- |
* | "Cipher" |
*
* @param {Theme_Cipher_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const theme_cipher_label = /** @type {((inputs?: Theme_Cipher_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Cipher_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_theme_cipher_label(inputs)
	if (locale === "de") return de_theme_cipher_label(inputs)
	if (locale === "el") return el_theme_cipher_label(inputs)
	if (locale === "en") return en_theme_cipher_label(inputs)
	if (locale === "es") return es_theme_cipher_label(inputs)
	if (locale === "fr") return fr_theme_cipher_label(inputs)
	if (locale === "hi") return hi_theme_cipher_label(inputs)
	if (locale === "hu") return hu_theme_cipher_label(inputs)
	if (locale === "id") return id_theme_cipher_label(inputs)
	if (locale === "it") return it_theme_cipher_label(inputs)
	if (locale === "ja") return ja_theme_cipher_label(inputs)
	if (locale === "ko") return ko_theme_cipher_label(inputs)
	if (locale === "nl") return nl_theme_cipher_label(inputs)
	if (locale === "pl") return pl_theme_cipher_label(inputs)
	if (locale === "pt") return pt_theme_cipher_label(inputs)
	if (locale === "ru") return ru_theme_cipher_label(inputs)
	if (locale === "sv") return sv_theme_cipher_label(inputs)
	if (locale === "tr") return tr_theme_cipher_label(inputs)
	if (locale === "uk") return uk_theme_cipher_label(inputs)
	if (locale === "vi") return vi_theme_cipher_label(inputs)
	if (locale === "zh") return zh_theme_cipher_label(inputs)
	return zh_hant_theme_cipher_label(inputs)
});